import * as React from 'react';
import { SVGProps } from 'react';

const SvgInstagram = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.307 4h6.72c2.56 0 4.64 2.08 4.64 4.64v6.72a4.64 4.64 0 0 1-4.64 4.64h-6.72c-2.56 0-4.64-2.08-4.64-4.64V8.64A4.64 4.64 0 0 1 8.307 4zm-.16 1.6a2.883 2.883 0 0 0-2.88 2.88v7.04a2.878 2.878 0 0 0 2.88 2.88h7.04a2.88 2.88 0 0 0 2.88-2.881v-7.04a2.878 2.878 0 0 0-2.88-2.88h-7.04zm7.72 1.2a.997.997 0 0 1 1 1 .997.997 0 0 1-1 1 .997.997 0 0 1-1-1 .997.997 0 0 1 1-1zm-4.2 1.2a4.003 4.003 0 0 1 2.828 6.829 3.997 3.997 0 0 1-5.656 0A4.002 4.002 0 0 1 11.667 8zm0 1.6a2.401 2.401 0 1 0 .001 4.802 2.401 2.401 0 0 0-.001-4.802z" />
  </svg>
);

export default SvgInstagram;
